module.exports = __webpack_public_path__ + "static/system-state-flow-assembling-@2x-024c53581005577cf1b89d0e5cff3b80.jpg";